import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=366a64ec&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=366a64ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a64ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366a64ec')) {
      api.createRecord('366a64ec', component.options)
    } else {
      api.reload('366a64ec', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=366a64ec&scoped=true&", function () {
      api.rerender('366a64ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dZ3OZJilSKp6/JS/comp/SearchFilterTokens.vue"
export default component.exports